import React from "react";
import { useTranslation } from "react-i18next";

import Caption from "components/caption";
import Currency from "components/currency";

export default function RatePriceBreakdown({ ratePlan, currency, propertyType }) {
  const { t } = useTranslation();
  const { netPrice, lengthOfStay, amount } = ratePlan;
  const pricePerNight = netPrice / lengthOfStay;

  return (
    <Caption>
      <Currency amount={pricePerNight} currency={currency} />
      {` × ${amount} ${t(`rates_table_${propertyType}.units`)} × ${lengthOfStay} ${t(`hotel_page_${propertyType}.duration_unit`)}`}
    </Caption>
  );
}
